import useTrack from '@/composables/use-track';

export default function trackHook() {
  try {
    const { facebookTrack } = useTrack();
    facebookTrack('PageView');
  } catch (error) {
    console.error('Error in page track:', error);
  }
}
